import { Injectable } from '@angular/core';
import { SharedService } from '../../shared/service/shared.service';
import { environment } from '../../../../environments/environment';

@Injectable()
export class FooterService {
	// Define valiables
	SITE_API_URL: any = '';
	data: any = {};

	// Define constructor
	constructor(public sharedService: SharedService) {
		this.SITE_API_URL = environment.API_URL;
	}

    /**this function is used to get global settings */
	getFooterSetting(): any {
        const methodName  				    = 'get_global_settings';
		const methodUrl 				    = environment.API_URL + methodName;
        this.data                           = {};
		return this.sharedService.getPost(methodUrl, this.data);
	}

	/**this function is used to get home page blocks */
	getStartedBlock(): any {
        const methodName  				    = 'home_page_block';
		const methodUrl 				    = environment.API_URL + methodName;
        this.data                           = {};
		this.data.data						= {};
		this.data.data.block_slug			= ['join-us','join-us-employer','footer-text'];
		return this.sharedService.getPost(methodUrl, this.data);
	}

	/**This function is used for get the feature category */
	getFeaturedCategory(): any {
		const methodName					= 'get_featured_category';
		const methodUrl						= environment.API_URL + methodName;
		this.data 							= {};
		return this.sharedService.getPost(methodUrl, this.data);
	}



  
	/**This function is used to get the notification counter */
	getNotificationCounter  = (formData:any): any => {
		const methodName					= 'get_notification_counter';
		const methodUrl						= environment.API_URL + methodName;
		this.data 							= {};
		this.data.data						= formData;
		return this.sharedService.getPost(methodUrl, this.data);
	} 


	sendChatMessage(formData: any): any {
		const methodName = 'chatbot_lex';
		const methodUrl = environment.API_URL + methodName; 
	  
		return this.sharedService.getPost(methodUrl, formData);
	  }


	  
	chatlist(formData: any): any {
		const methodName = 'chat_list';
		const methodUrl = environment.API_URL + methodName; 
	  
		return this.sharedService.getPost(methodUrl, formData);
	  }

	  	  
	messagelist(formData: any): any {
		const methodName = 'message_list';
		const methodUrl = environment.API_URL + methodName; 
	  
		return this.sharedService.getPost(methodUrl, formData);
	  }
}
